import { render } from "./UserJobs.vue?vue&type=template&id=665b2ab3&ts=true"
import script from "./UserJobs.vue?vue&type=script&lang=ts"
export * from "./UserJobs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__